var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-bar',{staticClass:"nav-bar-home"},[_c('div',{attrs:{"slot":"center"},slot:"center"},[_vm._v("购物街")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }